import { useTranslation } from '@/core/hooks';
import { useMemo } from 'react';
import { getAppointmentLabels } from '../constants/getAppointmentLabels';

export function useAppointmentLabels() {
  const { t } = useTranslation();
  return useMemo(() => getAppointmentLabels(t), [t]);
}
